import type { NonAgentJsonType } from '@bb/domain/dist/types/NonAgent';
import Axios from 'axios';

export type NonAgentSearchUser = Pick<
  NonAgentJsonType,
  'id' | 'org' | 'firstName' | 'lastName' | 'companyName' | 'type'
> & { score: number; fullName: string };

const search = async ({ name }: { name: string }) => {
  const { data } = await Axios.get<NonAgentSearchUser[]>('/nonagent/search', {
    params: { name },
  });
  return data;
};

export default search;
